(function () {
  if (window.__relatedProductsInit) return;
  window.__relatedProductsInit = true;

  // Fallback-CDN, falls das Theme Flickity auf der Produktseite nicht selbst lädt.
  // Besser: im Theme sicherstellen, dass flickity.pkgd.min.js dort vorhanden ist,
  // dann greift dieser Fallback nie.
  var FLICKITY_JS = 'https://cdnjs.cloudflare.com/ajax/libs/flickity/2.3.0/flickity.pkgd.min.js';
  var FLICKITY_CSS = 'https://cdnjs.cloudflare.com/ajax/libs/flickity/2.3.0/flickity.min.css';
  var DEFAULT_MONEY_FORMAT = '€{{amount_with_comma_separator}}';

  var flickityPromise = null;

  function ensureFlickity() {
    if (window.Flickity) return Promise.resolve(window.Flickity);
    if (flickityPromise) return flickityPromise;

    flickityPromise = new Promise(function (resolve, reject) {
      if (!document.querySelector('link[data-flickity-css]')) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = FLICKITY_CSS;
        link.setAttribute('data-flickity-css', '');
        document.head.appendChild(link);
      }
      var s = document.createElement('script');
      s.src = FLICKITY_JS;
      s.async = true;
      s.onload = function () { resolve(window.Flickity); };
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return flickityPromise;
  }

  // Shopify-Standard-Money-Formatter (liest das shop.money_format-Muster).
  function formatMoney(cents, format) {
    var formatString = format || DEFAULT_MONEY_FORMAT;
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';

      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }

    var match = formatString.match(placeholderRegex);
    if (!match) return formatString;

    var value = '';
    switch (match[1]) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function initVariants(item) {
    if (item.dataset.compInit) return;
    item.dataset.compInit = 'true';

    // Ohne Kauf-Formular (z. B. ausserhalb Deutschlands) nichts umschalten
    if (!item.querySelector('.js-comp-form')) return;

    var dataEl = item.querySelector('.js-variants');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var wrapper = item.closest('.complementary-products__wrapper');
    var moneyFormat = (wrapper && wrapper.dataset.moneyFormat) || DEFAULT_MONEY_FORMAT;

    var selects = Array.prototype.slice
      .call(item.querySelectorAll('.js-option-select'))
      .sort(function (a, b) { return a.dataset.index - b.dataset.index; });
    var variantInput = item.querySelector('.js-variant-id');
    var priceEl = item.querySelector('.complementary-products__price');
    var media = item.querySelector('img');
    var button = item.querySelector('.complementary-products__add-button');

    function update() {
      var chosen = selects.map(function (sel) { return sel.value; });
      var match = variants.find(function (v) {
        return chosen.every(function (val, i) { return v.options[i] === val; });
      });

      var available = !!match;
      if (variantInput) variantInput.value = match ? match.id : '';
      if (button) {
        button.disabled = !available;
        button.classList.toggle('disabled', !available);
      }
      if (!match) return;

      if (priceEl) priceEl.innerHTML = formatMoney(match.price, moneyFormat);
      if (media && match.featured_image_src) {
        media.src = match.featured_image_src;
        media.alt = match.public_title || match.title;
      }
    }

    selects.forEach(function (sel) { sel.addEventListener('change', update); });
    update();
  }

  function initSlider(slider) {
    if (slider.dataset.flickityInit) return;
    slider.dataset.flickityInit = 'true';

    ensureFlickity()
      .then(function (Flickity) {
        if (!Flickity || slider.classList.contains('flickity-enabled')) return;
        new Flickity(slider); // Optionen kommen aus data-flickity
      })
      .catch(function () {
        // Flickity nicht ladbar -> CSS-Fallback hält den Slider scrollbar.
        slider.removeAttribute('data-flickity-init');
      });
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('.complementary-products__item').forEach(initVariants);
    scope.querySelectorAll('.complementary-products__slider.js-flickity').forEach(initSlider);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) { init(e.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
})();
